import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import ReactModal from 'react-modal'

import styles from './modal.css'

class Modal extends React.Component {
  scrollToTop() {
    this.ref.portal.refs.overlay.scrollTop = 0
  }

  render() {
    const { closeModal, isOpen, title, children, light, wide } = this.props

    return (
      <ReactModal
        className={`modal ${wide ? 'modal--wide' : ''}`}
        isOpen={isOpen}
        onRequestClose={closeModal}
        ref={(c) => { this.ref = c }}
      >
        <div styleName={light ? 'content-light' : 'content-dark'}>
          {title &&
            <div styleName="header">{title}</div>
          }
          {children}
        </div>
      </ReactModal>
    )
  }
}

Modal.propTypes = {
  children: PropTypes.node,
  closeModal: PropTypes.func,
  isOpen: PropTypes.bool,
  light: PropTypes.bool,
  title: PropTypes.string,
  wide: PropTypes.bool,
}

export default CSSModules(Modal, styles)



/** WEBPACK FOOTER **
 ** ./src/components/modal/modal.js
 **/